export default __webpack_public_path__ + "static/media/Sponcerimage1.84a61c95.png";